export default "/assets/images/turn-on-mila-app.c76dbaa8b75f6218.webp";